import { render, staticRenderFns } from "./CampaignsTab.vue?vue&type=template&id=097c627f&"
import script from "./CampaignsTab.vue?vue&type=script&lang=js&"
export * from "./CampaignsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports